import { z } from 'zod';

import { ContentfulSysSchema } from './contentful-sys.validator';

export const SpecificationProviderEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    name: z.string(),
    type: z.string().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
